window.$ = window.jQuery = require('jquery');
require('./lib/featherlight.min.js');
import * as cookies from "./utils/cookies.js";


export function setAlerts() {

  $(document).ready(function() {

    let closeBtn = document.getElementById("closeAlert");
    let alerts = document.getElementById("alert");

    if (alerts) {
      $.featherlight($(alerts), {
        variant : 'alert',
        otherClose: '#closeAlert',
        afterOpen: function(){
          this.$content.find('.C20-copy a').on('click', function(e){
            e.preventDefault();
            cookies.setCookie("SERVICEALERT", "1", 1);
            window.location = this.href;
          });
        },
        afterClose: function(){
          cookies.setCookie("SERVICEALERT", "1", 1);
        }
      });
    }

  });


}



// WEBPACK FOOTER //
// ./resources/js/alerts.js